import {
  Avatar,
  AvatarBadge,
  Box,
  HStack,
  Heading,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Account, AccountRole } from "../graphql";
import { getFullName } from "../utils";

export type ShortAccount = Pick<Account, "role" | "profileImage"> & {
  profile?: {
    __typename?: "ClientProfile" | "DoctorProfile" | "SystemUserProfile";
    name?: string;
    lastname?: string;
  };
};

export interface IAccount {
  account: ShortAccount;
  size?: "md" | "sm" | "xs";
  role?: boolean;
}

export const AccountAvatar: React.FC<IAccount> = ({
  account,
  size = "md",
  role = true,
}) => {
  const { t } = useTranslation();

  if (!account) {
    return null;
  }
  const fullName = getFullName(account);

  const roleLabel = {
    [AccountRole.Admin]: t("roles.admin"),
    [AccountRole.Author]: t("roles.author"),
    [AccountRole.Doctor]: t("roles.doctor"),
    [AccountRole.MedicalSpecialist]: t("roles.specialist"),
  };

  return (
    <HStack>
      <Box>
        <Avatar name={fullName} src={account.profileImage} size={size}>
          {/* <AvatarBadge bg="green.500" /> */}
        </Avatar>
      </Box>
      <Box>
        {size === "md" ? (
          <>
            <Text fontWeight="bold">{fullName}</Text>
            <Text fontSize="xs">{roleLabel[account.role]}</Text>
          </>
        ) : null}

        {size === "sm" || size === "xs" ? (
          <>
            <Text>{fullName}</Text>
            {role && <Text>{account.role}</Text>}
          </>
        ) : null}
      </Box>
    </HStack>
  );
};
